import React from 'react';
import type { IHeaderParams } from 'ag-grid-community';
import { Icon } from 'venn-ui-kit';
import { Tooltip, TooltipContentWithArrow, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';

type RangeHeaderComponentProps = IHeaderParams & {
  isHistorical: boolean;
  title: string;
};

export const DateHeaderComponent = ({ title, isHistorical }: RangeHeaderComponentProps) => (
  <div className="flex gap-1">
    {title}
    <Tooltip>
      <TooltipTrigger>
        <Icon prefix="far" type="circle-info" iconLabel="Date header info icon" />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContentWithArrow>
          {isHistorical
            ? 'Based on returns data, allocations, and any applied proxies.'
            : 'Based on returns data and any applied proxies.'}
        </TooltipContentWithArrow>
      </TooltipPortal>
    </Tooltip>
  </div>
);
